import { render, staticRenderFns } from "./AddSection.vue?vue&type=template&id=297b1d6b&scoped=true"
import script from "./AddSection.vue?vue&type=script&lang=js"
export * from "./AddSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297b1d6b",
  null
  
)

export default component.exports